import { Tenant } from '../models/tenant.models';

export const TENANT_STORE_KEY = 'tenant';

export interface ITenantState {
  tenants: Tenant[];
  currentTenant: Tenant | null;
  isGlobalTenant: boolean;
}

export const initialState: ITenantState = {
  tenants: [],
  currentTenant: null,
  isGlobalTenant: false,
};
